const Line: React.FC <{}> = () => {
    return (
        <div className=" h-px bg-gray-500 m-6 justify-center"></div>
    )
}

export default Line;